import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SeoService } from './services/seo.service';
import { IosComingSoonDialogComponent } from './shared/ios-coming-soon-dialog/ios-coming-soon-dialog.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, IosComingSoonDialogComponent],
  template: `
    <router-outlet></router-outlet>
    <app-ios-coming-soon-dialog></app-ios-coming-soon-dialog>
  `
})
export class AppComponent implements OnInit {
  constructor(private seoService: SeoService) {}
  
  ngOnInit(): void {
    // SEO service is initialized and listening to route changes
  }
}
